/* eslint @typescript-eslint/explicit-function-return-type: 1, @typescript-eslint/no-explicit-any: 1 -- TODO fix types */
import { Injectable } from '@angular/core';
import { OneSignal } from 'onesignal-ngx';

@Injectable({ providedIn: 'root' })
export class OnesignalService {
  constructor(private oneSignal: OneSignal) {}

  init(options: { appId: string; autoRegister: boolean }): Promise<void> {
    return Promise.race<void>([
      this.oneSignal.init(options),
      new Promise((r) => setTimeout(() => r(), 2000)),
    ]);
  }

  async login(externalId: string): Promise<void> {
    // Check if externalId is valid before calling OneSignal
    if (!externalId || typeof externalId !== 'string') {
      console.warn('OneSignal login called with invalid externalId:', externalId);
      throw new Error('Invalid externalId provided to OneSignal login');
    }

    return this.oneSignal.login(externalId);
  }

  async logout(): Promise<void> {
    return this.oneSignal.logout();
  }

  async setEmail(email: string): Promise<void> {
    // Check if email is valid before calling OneSignal
    if (!email || typeof email !== 'string') {
      console.warn('OneSignal setEmail called with invalid email:', email);
      throw new Error('Invalid email provided to OneSignal setEmail');
    }

    return this.oneSignal.User.addEmail(email);
  }

  async setUserData(userData: Record<string, string>): Promise<void> {
    return this.oneSignal.User.addTags(userData);
  }

  async isPushNotificationsEnabled(): Promise<boolean> {
    return this.oneSignal.User.PushSubscription.optedIn || false;
  }

  async promptForPushNotifications(): Promise<void> {
    return this.oneSignal.Slidedown.promptPush();
  }
}
